module.exports = __webpack_public_path__ + "static/media/time-icon.6ce3f0fc.svg";